import React from 'react';
import {Card} from "antd";
import BidForm from "./BidForm";
import {compose} from "redux";
import {connect} from "react-redux";
import {createBid} from "../../actions/bids";

const BidNew = props => {
  const { codes, onSubmit, onCancel } = props;
  return <Card title='Bid Details' className={'edit-view'}>
    <BidForm codes={codes} onCancel={onCancel} onSubmit={onSubmit}/>
  </Card>;
};

export default compose(
  connect(
    null,
    (dispatch, props) => ({
      onSubmit: (bid) => dispatch(createBid(bid, (bidid) => props.history.push(`/bids/${bidid}`))),
      onCancel: () => props.history.goBack()
    })
  )
)(BidNew);



// WEBPACK FOOTER //
// ./src/components/Bids/BidNew.js